var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head /7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.464 242.477C462.812 299.041 492.736 332.937 495.53 385.727C499.126 453.625 460.19 446.449 463.14 502.167C464.67 531.043 207.432 600.749 134.936 509.951C88.4157 451.687 134.558 444.423 130.374 365.375C126.23 287.125 182.564 275.379 180.38 234.125C177.474 179.227 221.576 106.081 293.574 102.255C381.266 97.5974 456.914 156.985 460.464 242.477Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.37 375.288C329.37 375.288 303.586 377.422 292.258 371.992L328.9 392.374L329.37 375.288Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M270.304 327.059C279.104 339.585 276.686 356.831 272.592 367.051C271.212 370.561 262.584 399.837 261.172 401.217C255.684 406.569 327.764 433.541 327.764 433.541L329.37 375.287C349.856 375.383 373.77 373.033 386.47 363.579C424.302 335.417 421.826 244.853 420.944 240.363L386.102 205.315C386.102 205.315 335.29 185.043 328.258 195.175C315.396 213.731 287.316 295.201 263.442 287.339C263.442 287.339 265.078 262.387 244.382 263.515C228.962 264.355 225.442 276.947 225.832 284.091C227.146 308.209 258.486 310.183 270.304 327.059Z",
    fill: "#72A065"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.868 284.571L397.548 319.617L380.384 320.183L380.868 284.571Z",
    fill: "#125475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.215 286.96C365.227 294.138 361.313 299.938 356.473 299.916C351.633 299.894 347.701 294.056 347.689 286.88C347.677 279.702 351.591 273.902 356.431 273.924C361.271 273.946 365.203 279.784 365.215 286.96Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.465 283.413C410.477 290.591 406.563 296.391 401.723 296.369C396.883 296.347 392.951 290.509 392.939 283.333C392.927 276.155 396.841 270.355 401.681 270.377C406.521 270.399 410.453 276.237 410.465 283.413Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.386 146.109C394.09 144.201 395.897 142.383 397.799 140.661C402.067 144.323 406.113 148.231 409.893 152.387C430.227 174.705 443.225 203.711 444.981 235.941C445.027 236.757 445.069 237.553 445.095 238.369H445.115L446.539 264.483C445.527 264.499 444.533 264.475 443.519 264.433C423.717 263.545 405.811 254.825 393.179 241.201C388.495 236.141 384.529 230.399 381.447 224.139C380.961 223.211 380.531 222.241 380.101 221.311C377.956 216.358 376.358 211.111 375.385 205.645C307.703 301.236 263.443 287.34 263.443 287.34L269.859 237.342L220.537 184.292C220.537 184.292 361.195 123.519 392.386 146.109Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.386 146.109C394.09 144.201 395.897 142.383 397.799 140.661C402.067 144.323 406.113 148.231 409.893 152.387C430.227 174.705 443.225 203.711 444.981 235.941C445.027 236.757 445.069 237.553 445.095 238.369H445.115L446.539 264.483C445.527 264.499 444.533 264.475 443.519 264.433C423.717 263.545 405.811 254.825 393.179 241.201C388.495 236.141 384.529 230.399 381.447 224.139C380.961 223.211 380.531 222.241 380.101 221.311C377.956 216.358 376.358 211.111 375.385 205.645C307.703 301.236 263.443 287.34 263.443 287.34L269.859 237.342L220.537 184.292C220.537 184.292 361.195 123.519 392.386 146.109Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M377.087 337.568C377.087 337.568 366.107 341.766 354.251 329.912",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    opacity: 0.396996,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.328 375.29C329.328 375.29 303.544 377.422 292.216 371.994L328.858 392.376L329.328 375.29Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead7);
export default __webpack_public_path__ + "static/media/Girl-Head-7.4562c477.svg";
export { ForwardRef as ReactComponent };